<ng-template #shapeTemplate>
    <svg:text attr.id="{{shape.shapeProperties.name}}" class="draggable" attr.x="{{ shape.originX }}" attr.font-family="{{shape['font-family']}}" attr.font-size="{{shape['font-size']}}" attr.fill="{{shape.fill}}" attr.y="{{ shape.originY }}" [ngStyle]="setStyles()">{{ shape.value }}
        <title>{{ shape.shapeProperties.name }}</title>
    </svg:text>
</ng-template>